import { get, httpDelete, post } from "@readai/common/api";
import type {
  ApiEnterpriseSearchResponse,
  EnterpriseSearchQueryRequest,
  EnterpriseSearchResponse,
  SharedSearch,
  SharedSearches,
  SharedSearchesPaginationOpts,
} from "@readai/common/types/enterpriseSearchTypes";

import { withQueryParamsUrl } from "../utils";
import * as EnterpriseSearchParser from "./parsers/enterpriseSearch";

export const search = async (
  request: EnterpriseSearchQueryRequest,
): Promise<EnterpriseSearchResponse> => {
  const body = EnterpriseSearchParser.transformRequest(request);
  const resp = await post("/discovery/v0/enterprise/search", body, {
    withCreds: true,
  });
  const response = resp as ApiEnterpriseSearchResponse;
  return EnterpriseSearchParser.parseResponse(response);
};

export const shareSearch = (id: string): Promise<SharedSearch> =>
  post("/share-search-results", { id }, { withCreds: true });

export const getSharedSearch = async (id: string): Promise<SharedSearch> => {
  const resp = await get(`/share-search-results/${id}/result`);
  return EnterpriseSearchParser.parseSharedSearch(resp);
};

export const deleteSharedSearch = (id: string): Promise<void> =>
  httpDelete(`/share-search-results/${id}`, {
    withCreds: true,
  });

export const getSharedSearches = async ({
  limit,
  offset,
}: SharedSearchesPaginationOpts): Promise<SharedSearches> => {
  const url = withQueryParamsUrl("/share-search-results", {
    limit: String(limit),
    offset: String(offset),
  });
  const resp = await get(url, { withCreds: true });
  return EnterpriseSearchParser.parseSharedSearches(resp);
};
